import { put } from 'redux-saga/effects';
import { getApplicationFaq } from '../../api/applicationFaqAPI';
import * as types from './faqActionTypes';

export function* getFaqSaga({ faqId }) {
  try {
    const faq = yield getApplicationFaq(faqId);
    if (faq && faq.error) {
      yield put({
        type: types.GET_FAQ_ERROR,
        error: faq.error,
      });
    } else {
      yield put({
        type: types.GET_FAQ_SUCCESS,
        faq,
      });
    }
  } catch (error) {
    yield put({
      type: types.GET_FAQ_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/faq/faqSaga.js